export default function Projects() {
    return (
        <div className="projects-container">
            <a href="/projects/photography" className="projects_link">
                photography
            </a>
            <a href="/projects/3dgs" className="projects_link">
                3dgs
            </a>
            <a href="/projects/arev" className="projects_link">
                arev
            </a>
            <a href="/projects/webcam" className="projects_link">
                ascii webcam
            </a>
        </div>
    );
} 
